<template>
	<div
	v-touch:tap="tapHandler"
	v-touch:swipe.left="swipeLeftHandler"
	v-touch:swipe.right="swipeRightHandler"
	@contextmenu.prevent="contextMenuHandler"
	style="user-select: none;"
	@keyup.enter="tapHandler"
	tabindex="0"
	role="link"
	>

		<template v-if="data">

			<div class="float-left">
				<p class="bold mt-0 mb-0">
					<strong>
						{{ data.Code }}:
						{{ data.Name }}
					</strong>
				</p>
				<p class="small mt-0 mb-0">
					<b-icon icon="person" class="mr-1" />
					{{
						isTeacher
							? data.student_displayname
							: data.teacher_displayname
					}}
				</p>
				<p class="small mt-0 mb-0">
					<b-icon icon="clock" class="mr-1" />
					{{ $t('date-taken-colon') }}
					{{ $datetime.getLocaleStringFromTimeStamp(data.DateTaken) }}
				</p>
				<p class="small mt-0 mb-0">
					<b-icon icon="calendar" class="mr-1" />
					{{ $t('created-colon') }}
					{{ $datetime.getLocaleStringFromTimeStamp(data.DateAdded) }}
				</p>
			</div>

			<button class="btn btn-danger float-right ml-2" v-if="showDeleteBtn" v-touch:tap.stop="deleteTestSession">{{$t('delete')}}</button>

			<div class="float-right mt-3" v-if="!showDeleteBtn">
				<LabelIndicator v-if="data.HasPassed === 1" type="success">{{getDichotomy('true')}}</LabelIndicator>
				<LabelIndicator v-if="data.HasPassed === 0" type="danger">{{getDichotomy('false')}}</LabelIndicator>
			</div>



		</template>

		<template v-else>

			<div class="float-left">
				<div class="skeleton midnight h20 w200 mb-3"></div>
				<div class="skeleton midnight h20 w50"></div>
			</div>
			<div class="float-right">
				<div class="skeleton midnight h20 w200"></div>
			</div>

		</template>

	</div>
</template>

<script>
import LabelIndicator from "src/components/LabelIndicator";
export default {
	components: {
		LabelIndicator
	},
	props: ['data', 'swipedLeftItem'],
	methods: {
		deleteTestSession() {
			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/session/delete`, {
				data: {
					id: this.data.CompetencyTestSessionID
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$emit('removeItem', this.data);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		tapHandler(e) {

			// prevent tap for right clicks
			if(e.button && e.button == 2) {
				return false;
			}

			if(this.data) {
				this.$emit('selectItem', this.data);
			}
		},
		swipeLeftHandler() {
			this.$emit('swipeLeftItem', this.data);
		},
		swipeRightHandler() {
			this.$emit('swipeRightItem', this.data);
		},
		contextMenuHandler() {
			this.$emit('contextMenuItem', this.data);
		},
		getDichotomy(type){
			if(this.$config.getValue('dichotomies') && this.data.dichotomy_id in this.$config.getValue('dichotomies')){
				return this.$config.getValue('dichotomies')[this.data.dichotomy_id][type]
			}
			if(type == 'true'){
				return this.$t('pass');
			}
			if(type == 'false'){
				return this.$t('fail');
			}
		}
	},
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		},
		isStudent: function() {
			return this.$UserSession.hasPriv.call(this, "APP_STUDENT");
		},
		canDelete() {
			// if not marked or assigned teacher or VIEW_ALLTESTS
			return this.data.HasPassed == -1 || this.$UserSession.getValue('id') == this.data.teacher_id || this.$UserSession.hasPriv.call(this, "VIEW_ALLTESTS");
		},
		showDeleteBtn() {
			return (this.swipedLeftItem && this.swipedLeftItem.CompetencyTestSessionID == this.data.CompetencyTestSessionID) && this.canDelete;
		},
	}
};
</script>
